import cx from 'clsx';

import { Image } from '@shared/components/core';

import InfoRed from '@assets/icons/infoExclamationRed.svg';

import styles from './HelperText.module.scss';

export interface HelperTextProps {
	message: string;
	label: string;
}

const HelperText = ({ message, label }: HelperTextProps) =>
	message ? (
		<div
			className={cx(
				'h6 mt1 overflow-hidden d-flex justify-start items-start',
				styles.errorMessage,
				{
					[styles.show]: message,
				},
			)}
			id="input-error-text"
		>
			<Image src={InfoRed} alt={`${label} error`} className="mr1" />
			{message}
		</div>
	) : null;

export default HelperText;
